export default "__VITE_ASSET__74487827__"